import { activity_recent, and, desc, eq, type PowerSyncDrizzleDB } from "@stockpilot/powersync";

const DEFAULT_FEED_LIMIT = 200;

/**
 * Feed de actividad local (stream PowerSync `activity_recent`, ~90 días).
 *
 * El SQLite de la cuenta contiene TODOS sus streams a la vez: el scope personal
 * (`scope_id = user_id`) Y el de TODAS sus organizaciones. Multi-organización:
 * el feed debe mostrar SOLO la actividad de la empresa ACTIVA, así que se filtra
 * por `scopeId` (= `organization_id` activo, o el userId en Personal). Sin el
 * filtro, al ver la empresa A se colaría la actividad de la B (fuga entre
 * empresas). Si no se pasa `scopeId` se devuelve todo (compatibilidad).
 *
 * Orden canónico: server_ts DESC (desempate por id UUIDv7).
 */
export function getActivityFeedQuery(
  db: PowerSyncDrizzleDB,
  options: { limit?: number; scopeId?: string } = {},
) {
  const base = db.select().from(activity_recent);
  const scoped = options.scopeId ? base.where(eq(activity_recent.scope_id, options.scopeId)) : base;
  return scoped
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}

/**
 * Historial local de una entidad concreta (para el sheet "Historial" del
 * detalle). El historial profundo (más allá de la retención) se pide a la API
 * (`GET /api/activity/entity/:type/:id`).
 */
export function getEntityActivityQuery(
  db: PowerSyncDrizzleDB,
  entityType: string,
  entityId: string,
  options: { limit?: number } = {},
) {
  return db
    .select()
    .from(activity_recent)
    .where(
      and(eq(activity_recent.entity_type, entityType), eq(activity_recent.entity_id, entityId)),
    )
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}
